interface Props {
  header: string;
  messages: string[];
}

export function InfoBlock({
  header,
  messages,
}: Props) {
  return (
    <div style={{
      height: "476px",
      textAlign: "center",
      alignContent: "center",
      border: "1px solid #E5E5E5",
      borderRadius: "4px",
      marginBottom: "1rem",
    }}>
      <h3>{header}</h3>
      {messages.map((message) => (
        <p key={message}>{message}</p>
      ))}
    </div>
  );
};